import fetch                from '../../../utils/browser-fetch';
import busyActionFactory    from '../../../busy';
import { addError }         from '../../../errors-dux';
import Errors               from '../../../errors';
import { addSuccessString } from '../../../success-dux';
import SuccessString        from '../../../success';

/******************
 * Initial state
 */
const initialState = {
    usernameRequested: false,
    busy: false
};

/******************
 * Non-async action types
 */
export const BUSY_REQUEST_USERID = 'BUSY_REQUEST_USERID';


/******************
 * Reducer
 */
export default function forgotUserIdData( state = initialState, action ) {
    switch ( action.type ) {
        case BUSY_REQUEST_USERID:
            return {
                ...state,
                busy: action.busy
            };
        default:
            return state;
    }
}


/******************
 * Action creators
 */

const busyRequestingUserId = busyActionFactory( BUSY_REQUEST_USERID );
export function requestUsername( emailAddress ) {
    // we have this string here since the service doesn't return an explicit success code or indicator
    // we infer it out of the response and construct our own (more) proper response
    const successMessage = 'forgotUserId.form.successMessage';
    return dispatch => {
        dispatch( busyRequestingUserId( true ) );

        const reqObj = {
            emailAddress
        };
        return fetch( '/api/v1.0/forgotUsername', {
            method: 'post',
            body: reqObj
        } )
            .then( ( { result } ) => {
                dispatch( busyRequestingUserId( false ) );
                dispatch( addSuccessString( true, successMessage, SuccessString.SUCCESS_FORGOTUSERID_REQUESTUSERNAME ) );
            } )
            .catch( ( error ) => {
                dispatch( busyRequestingUserId( false ) );
                dispatch( addError( error, Errors.ERROR_FORGOTUSERID_REQUESTUSERNAME ) );
            } );
    };
}
